import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a69cedce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "users-body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Nome", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Usuário", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Status", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Funções", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Data de Criação", -1))
const _hoisted_7 = { class: "field" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "label"
}, "Nome", -1))
const _hoisted_9 = { class: "control" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "area-content" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Função", -1))
const _hoisted_13 = { class: "check-grid" }
const _hoisted_14 = { class: "checkbox" }
const _hoisted_15 = { class: "radio" }
const _hoisted_16 = { class: "checkbox" }
const _hoisted_17 = { class: "radio" }
const _hoisted_18 = { class: "area-content" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Permissões", -1))
const _hoisted_20 = { class: "checkbox" }
const _hoisted_21 = { class: "checkbox" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "checkbox" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "checkbox" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { class: "checkbox" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = { class: "button-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TitleBar = _resolveComponent("TitleBar")!
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_UserCard = _resolveComponent("UserCard")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TitleBar, { title: "Usuários" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PageHeader, null, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _hoisted_6
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
        return (_openBlock(), _createBlock(_component_UserCard, {
          onClick: ($event: any) => (_ctx.showModal(user)),
          key: user.name,
          user: user
        }, null, 8, ["onClick", "user"]))
      }), 128)),
      (_ctx.selectedUser)
        ? (_openBlock(), _createBlock(_component_Modal, {
            key: 0,
            onCloseModalClick: _ctx.hideModal,
            "is-active": _ctx.modalActive,
            title: _ctx.selectedUser?.username
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-user" })
            ]),
            body: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("input", {
                    id: "name",
                    type: "text",
                    class: "input",
                    placeholder: "Nome",
                    value: _ctx.selectedUser?.name
                  }, null, 8, _hoisted_10)
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_14, [
                      _createElementVNode("label", _hoisted_15, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          class: "radio",
                          name: "role",
                          value: "ADMIN",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.role) = $event))
                        }, null, 512), [
                          [_vModelRadio, _ctx.role]
                        ]),
                        _createTextVNode(" Administrador ")
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_16, [
                      _createElementVNode("label", _hoisted_17, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          class: "radio",
                          name: "role",
                          value: "USER",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.role) = $event))
                        }, null, 512), [
                          [_vModelRadio, _ctx.role]
                        ]),
                        _createTextVNode(" Usuário ")
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("label", _hoisted_20, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "checkbox",
                    value: "all",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.setTotalControl && _ctx.setTotalControl(...args))),
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.permissions) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.permissions]
                  ]),
                  _createTextVNode("Controle Total ")
                ]),
                _createElementVNode("label", _hoisted_21, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "checkbox",
                    value: "read",
                    onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.verifyPermissions && _ctx.verifyPermissions(...args))),
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.permissions) = $event)),
                    disabled: _ctx.permissions.includes('all')
                  }, null, 40, _hoisted_22), [
                    [_vModelCheckbox, _ctx.permissions]
                  ]),
                  _createTextVNode("Leitura ")
                ]),
                _createElementVNode("label", _hoisted_23, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "checkbox",
                    value: "create",
                    onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.verifyPermissions && _ctx.verifyPermissions(...args))),
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.permissions) = $event)),
                    disabled: _ctx.permissions.includes('all')
                  }, null, 40, _hoisted_24), [
                    [_vModelCheckbox, _ctx.permissions]
                  ]),
                  _createTextVNode("Criação ")
                ]),
                _createElementVNode("label", _hoisted_25, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "checkbox",
                    value: "update",
                    onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.verifyPermissions && _ctx.verifyPermissions(...args))),
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.permissions) = $event)),
                    disabled: _ctx.permissions.includes('all')
                  }, null, 40, _hoisted_26), [
                    [_vModelCheckbox, _ctx.permissions]
                  ]),
                  _createTextVNode("Atualização ")
                ]),
                _createElementVNode("label", _hoisted_27, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "checkbox",
                    value: "delete",
                    onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.verifyPermissions && _ctx.verifyPermissions(...args))),
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.permissions) = $event)),
                    disabled: _ctx.permissions.includes('all')
                  }, null, 40, _hoisted_28), [
                    [_vModelCheckbox, _ctx.permissions]
                  ]),
                  _createTextVNode("Exclusão ")
                ])
              ])
            ]),
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("button", {
                  class: "button delete-button",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.deleteUser(_ctx.selectedUser!.id)))
                }, "Excluir"),
                _createElementVNode("button", {
                  class: "button save-button",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.saveUser(_ctx.selectedUser!, _ctx.role, _ctx.permissions)))
                }, "Salvar")
              ])
            ]),
            _: 1
          }, 8, ["onCloseModalClick", "is-active", "title"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}